<template>
  <tw-custom-dialog transition="fadet"
                    width="600"
                    v-model="dialog">

    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Cadastro tag
    </template>
    <template>
      <v-row dense>
        <v-col cols="12" sm="12" md="12">
          <v-text-field outlined
                        hide-details
                        maxlength="255"
                        class="required"
                        label="Nome do Tag"
                        :error="$v.tagEdit.nome.$error"
                        @blur="$v.tagEdit.nome.$touch()"
                        v-model="tagEdit.nome"/>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <tw-color-picker
            label="Cor"
            v-model="tagEdit.cor"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="mr-2"
             :loading="loadingForm"
             :disabled="$v.$invalid"
             @click="save">
        Salvar
      </v-btn>
      <v-btn @click="close">Cancelar</v-btn>
    </template>

  </tw-custom-dialog>
</template>

<script>
import TagService from '@/api/tag-service';
import { required } from 'vuelidate/lib/validators';
import _ from 'lodash';

function resetEdit() {
  return {
    nome: null,
    cor: '#FF0606',
  };
}

export default {
  props: {
    tag: Object,
  },
  data() {
    return {
      tagEdit: resetEdit(),
      dialog: false,
      loadingForm: false,
    };
  },
  watch: {
    dialog() {
      if (this.tag) {
        this.tagEdit = _.cloneDeep(this.tag);
      } else {
        this.tagEdit = resetEdit();
      }
      this.$v.$reset();
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    save() {
      this.loadingForm = true;
      TagService.save(this.tagEdit)
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Tag salva', { color: 'success' });
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
  },
  validations: {
    tagEdit: {
      nome: {
        required,
      },
    },
  },
};
</script>
